import React, { memo, useContext } from 'react';
import AppContext, { ChatContext } from 'context/Context';
import elvis from 'assets/img/elvis/elvis.png';
import './elvis-button.css';
import ChatWindow from './ChatWindow';

const ElvisToggleBtn = () => {
    const { setChatWindowOpen, chatWindowOpen } = useContext(ChatContext);
    const { config: { showElvis } } = useContext(AppContext);

    if (!showElvis) {
        // Force close chat window if left open
        if (chatWindowOpen) setChatWindowOpen(false);
        return <></>;
    }

    return (
        <>
            <div className="chat-btn-container">
                <button className="bg-primary border-0 rounded-circle shadow chat-btn" onClick={() => setChatWindowOpen(prev => !prev)}>
                    <img height={50} width={50} src={elvis} />
                </button>
            </div>
            <ChatWindow />
        </>
    );
}

export default memo(ElvisToggleBtn);